import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { DELETE_EXAM_FEE_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface DeleteExamFeeRequest {
  examFeeUuid: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteExamFee = ({ onSuccess, onError }: Input) => {
  const deleteExamFee = async (payload: DeleteExamFeeRequest) => {
    const res = await axiosClient.delete<void>(DELETE_EXAM_FEE_URL(payload.examFeeUuid));
    return res.data;
  };

  return useCustomMutation(deleteExamFee, {
    onSuccess,
    onError,
  });
};
